import { Component } from "@angular/core";

@Component({
  selector: "app-simple-patient-list-page",
  templateUrl: "./simple-patient-list-page.component.html",
  styleUrls: ["./simple-patient-list-page.component.scss"],
})
export class SimplePatientListPageComponent {}
